<template>
    <div class="ci-select">
        <label v-show="label">
            <span class="text-secondary" v-if="required">*</span>
            {{ label }}
        </label>
        <treeselect :placeholder="placeholder" v-model="selectedOption" :multiple="false" :options="options" :disable-branch-nodes="selectableRoot">
            <div slot="value-label" slot-scope="{ node }">
                <slot name="value" :node="node"> </slot>
            </div>
            <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }">
                <slot
                    name="option"
                    :node="node"
                    :shouldShowCount="shouldShowCount"
                    :count="count"
                    :labelClassName="labelClassName"
                    :countClassName="countClassName"
                >
                </slot>
            </div>
        </treeselect>
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    components: {
        Treeselect,
    },
    props: {
        placeholder: {
            type: String,
        },
        label: {
            type: String,
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
        },
        required: Boolean,
        value: null,
        // prop for desabiliting the option to click the parent option
        selectableRoot: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        value: {
            handler() {
                this.selectedOption = this.value
            },
        },
        selectedOption: {
            handler() {
                this.$emit('input', this.selectedOption)
            },
            deep: true,
        },
    },
    data() {
        return {
            selectedOption: null,
        }
    },
    mounted() {
        this.selectedOption = this.value
    },
}
</script>

<style lang="scss" scoped>
.ci-select {
    background: inherit;
    position: relative;
    margin-top: 8px;
    label {
        background-color: inherit;
        z-index: 1;
        position: absolute;
        margin: 0px;
        left: 8px;
        top: -8px;
        padding: 0 8px;
        color: #808080;
        margin: 0px;
        font-size: 12px;
        @media (max-width: 1200px) {
            font-size: 10px;
        }
    }
}
</style>
